// Maps preference index to chart colour CSS variables from globals.css
// Cycles through chart-1 to chart-5 for any number of preferences
const CHART_COLOURS = [
    "var(--color-chart-1)",
    "var(--color-chart-2)",
    "var(--color-chart-3)",
    "var(--color-chart-4)",
    "var(--color-chart-5)",
];

export function getPreferenceColour(index: number): string {
    return CHART_COLOURS[index % CHART_COLOURS.length];
}
